
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'headerComponentMjstoreCustomerListWithCustomerType',
  props: {
    tableHead: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  setup() {
    return {};
  },
});
